// src/components/Projects.js

import { CodeIcon } from "@heroicons/react/solid";
import {TfiWorld} from "react-icons/tfi"
import { FiGithub } from "react-icons/fi";
import { IoLogoYoutube } from "react-icons/io";
import React from "react";
import { projects } from "../data";
import IconButton from "./IconButton";

export default function Projects() {
  return (
    <section id="projects" className="text-gray-400 bg-gray-900 body-font">
      <div className="container px-5 py-10 mx-auto text-center lg:px-40">
        <div className="flex flex-col w-full mb-20">
          <CodeIcon className="mx-auto inline-block w-10 mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
            Apps I've Built
          </h1>

          <p className="lg:w-2/3 mx-auto leading-relaxed text-base mb-4">
            See more projects and repositories on my Github account.
          </p>

          <div className="flex justify-center">
            <a href="https://github.com/storres20" target="_blank" rel="noreferrer">
              <svg className="h-16 w-16 text-gray-400 hover:text-violet-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" /></svg>
            </a>
            
          </div>

        </div>
        <div className="flex flex-wrap -m-4">
          {projects.map((project) => (
            <div
              key={project.image}
              className="sm:w-1/2 w-100 p-4">
              <div className="flex relative">
                <img
                  alt="gallery"
                  className="absolute inset-0 w-full h-full object-cover object-center"
                  src={require('../' + project.image + '.gif')}
                />
                <div className="px-8 py-10 relative z-10 w-full border-4 border-gray-800 bg-gray-900 opacity-0 hover:opacity-100">
                  <h2 className="tracking-widest text-sm title-font font-medium text-green-400 mb-1">
                    {project.subtitle}
                  </h2>
                  <h1 className="title-font text-lg font-medium text-white mb-3">
                    {project.title}
                  </h1>
                  <p className="leading-relaxed">{project.description}</p>
                </div>
              </div>
              <div className="pt-2 text-green-500 font-bold flex items-center flex-row justify-center flex-wrap gap-2">
                <span className="border border-green-500 rounded-lg p-2">{project.stack[0]}</span>
                <span className="border border-green-500 rounded-lg p-2">{project.stack[1]}</span>
                <span className="border border-green-500 rounded-lg p-2">{project.stack[2]}</span>
              </div>
              <div className="flex justify-center mt-2">
                <a
                  href={project.link}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex text-white border-0 focus:outline-none rounded text-lg">
                  <IconButton text="Link" color="bg-green-500" textcolor="text-black">
                    <TfiWorld/>
                  </IconButton>
                </a>
                <a
                  href={project.github}
                  target="_blank"
                  rel="noreferrer"
                  className="ml-4 inline-flex text-gray-400 border-0 focus:outline-none hover:text-white rounded text-lg">
                  <IconButton text="Github" color="bg-gray-700">
                    <FiGithub/>
                  </IconButton>
                </a>
                {project.youtube && (
                  <a
                    href={project.youtube}
                    target="_blank"
                    rel="noreferrer"
                    className="ml-4 inline-flex text-black border-0 focus:outline-none hover:text-black rounded text-lg"
                  >
                    <IconButton text="Youtube" color="bg-red-500">
                      <IoLogoYoutube />
                    </IconButton>
                  </a>
                )}

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
